import React, { Component } from 'react';
import articles from "../../api/articles.json"
import { Helmet } from "react-helmet"
import 'whatwg-fetch'
import "./Article.scss"

class Article extends Component {
  constructor() {
    super();
    this.fetchArticle = this.fetchArticle.bind(this);
    this.state = {
      articleID: 1,
      articleHead: "",
      articleDesc: "",
      articleImage: "",
      articleHTML: "",
      articleImageCredit: "",
      isLoaderActive: "active"
    }
  }
  jsLoader(u) {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = u;
    var x = document.getElementsByTagName('head')[0];
    x.appendChild(s);
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    //this.fetchArticle(this.props.match.params.id);
  }
  componentDidMount() {
    this.jsLoader("//cdn.playbuzz.com/widget/feed.js");
    window.document.querySelector("body").classList.add("article");
    this.fetchArticle(this.props.match.params.id);

    var urlToGoogle = window.location.href;
    urlToGoogle = urlToGoogle.split("#");
    urlToGoogle = window.location.pathname + "#" + urlToGoogle[1];

    console.log(urlToGoogle);

    window.dataLayer.push({
      'event': 'virtualPageview',
      'virtualPageURL': urlToGoogle,
      'virtualPageTitle': articles[this.props.match.params.id - 1].name
    });
  }
  componentWillReceiveProps(nextProps) {
    this.fetchArticle(nextProps.match.params.id);

    var urlToGoogle = window.location.href;
    urlToGoogle = urlToGoogle.split("#");
    urlToGoogle = window.location.pathname + "#" + urlToGoogle[1];

    console.log(urlToGoogle);

    window.dataLayer.push({
      'event': 'virtualPageview',
      'virtualPageURL': urlToGoogle,
      'virtualPageTitle': articles[nextProps.match.params.id - 1].name
    });
  }
  fetchArticle(id) {
    var articleID = id;
    this.setState({
      articleID: articleID,
      articleHead: articles[articleID - 1].name,
      articleDesc: articles[articleID - 1].desc,
      articleImage: "./static/images/pages/" + articles[articleID - 1].image,
      articleImageCredit: articles[articleID - 1].credit,
      isLoaderActive: "active"
    })

    fetch("./static/articles/article_" + articleID + ".html")
      .then(data => data.text())
      .then(data => {
        this.setState({
          articleHTML: data,
          isLoaderActive: ""
        })
      })
      .catch(err => console.error(this.props.url, err.toString()));

    if (articles[articleID - 1].image === "") {
      window.document.querySelector(".image").innerHTML = "";
    }
  }
  render() {
    return (
      <div className="Isracard-Wrapper-Article">
        <Helmet>
          <title>{articles[this.state.articleID - 1].title}{articles[this.state.articleID - 1].name}</title>
        </Helmet>
        <div dangerouslySetInnerHTML={{
          __html: `<script>
  gtag('event', 'conversion', {
      'send_to': 'AW-880221962/4FjOCKWkx3oQir7cowM',
      'aw_remarketing_only': true,
      'value': 1.0,
      'currency': 'ILS'
  });
fbq('track', 'ynet- visit aricle');
</script>`}}></div>
        <section className="section section-article">
          <div className={"padding " + this.state.isLoaderActive}>
            <div className="loading">
              <div className="loader" id="loader-1"></div>
            </div>
            <div className="headline">
              <h1>{this.state.articleHead}</h1>
              <h4>{this.state.articleDesc}</h4>
            </div>
            <div className="linebreak"></div>
            <div className="image">
              <img src={this.state.articleImage} alt="" title="" />
              <div className="credit">
                צילום: {this.state.articleImageCredit}
              </div>
            </div>
            <div className="article" dangerouslySetInnerHTML={{ __html: this.state.articleHTML }}>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Article;



// WEBPACK FOOTER //
// ./src/components/App/Article.js